// USER LIST
export const BUSINESS_UNIT_LIST = "BUSINESS_UNIT_LIST";
export const BUSINESS_UNIT_LIST_SUCCESS = "BUSINESS_UNIT_LIST_SUCCESS";
export const BUSINESS_UNIT_LIST_FAIL = "BUSINESS_UNIT_LIST_FAIL";
export const BUSINESS_UNIT_LIST_RESET = "BUSINESS_UNIT_LIST_RESET";
export const BUSINESS_UNIT_LIST_COLUMN = "BUSINESS_UNIT_LIST_COLUMN";

// USER ROLE LIST
export const BUSINESS_UNIT_ROLE_LIST = "BUSINESS_UNIT_ROLE_LIST";
export const BUSINESS_UNIT_ROLE_LIST_SUCCESS = "BUSINESS_UNIT_ROLE_LIST_SUCCESS";
export const BUSINESS_UNIT_ROLE_LIST_FAIL = "BUSINESS_UNIT_ROLE_LIST_FAIL";
export const BUSINESS_UNIT_ROLE_LIST_RESET = "BUSINESS_UNIT_ROLE_LIST_RESET";
export const BUSINESS_UNIT_ROLE_LIST_COLUMN = "BUSINESS_UNIT_ROLE_LIST_COLUMN";

// USER CREATE
export const BUSINESS_UNIT_CREATE = "BUSINESS_UNIT_CREATE";
export const BUSINESS_UNIT_CREATE_SUCCESS = "BUSINESS_UNIT_CREATE_SUCCESS";
export const BUSINESS_UNIT_CREATE_FAIL = "BUSINESS_UNIT_CREATE_FAIL";
export const BUSINESS_UNIT_CREATE_RESET = "BUSINESS_UNIT_CREATE_RESET";

// USER DETAIL
export const BUSINESS_UNIT_DETAIL = "BUSINESS_UNIT_DETAIL";
export const BUSINESS_UNIT_DETAIL_SUCCESS = "BUSINESS_UNIT_DETAIL_SUCCESS";
export const BUSINESS_UNIT_DETAIL_FAIL = "BUSINESS_UNIT_DETAIL_FAIL";
export const BUSINESS_UNIT_DETAIL_RESET = "BUSINESS_UNIT_DETAIL_RESET";

// USER UPDATE
export const BUSINESS_UNIT_UPDATE = "BUSINESS_UNIT_UPDATE";
export const BUSINESS_UNIT_UPDATE_SUCCESS = "BUSINESS_UNIT_UPDATE_SUCCESS";
export const BUSINESS_UNIT_UPDATE_FAIL = "BUSINESS_UNIT_UPDATE_FAIL";
export const BUSINESS_UNIT_UPDATE_RESET = "BUSINESS_UNIT_UPDATE_RESET";

// USER DELETE
export const BUSINESS_UNIT_DELETE = "BUSINESS_UNIT_DELETE";
export const BUSINESS_UNIT_DELETE_SUCCESS = "BUSINESS_UNIT_DELETE_SUCCESS";
export const BUSINESS_UNIT_DELETE_FAIL = "BUSINESS_UNIT_DELETE_FAIL";
export const BUSINESS_UNIT_DELETE_RESET = "BUSINESS_UNIT_DELETE_RESET";

// USER ACTIVE
export const BUSINESS_UNIT_ACTIVE = "BUSINESS_UNIT_ACTIVE";
export const BUSINESS_UNIT_ACTIVE_SUCCESS = "BUSINESS_UNIT_ACTIVE_SUCCESS";
export const BUSINESS_UNIT_ACTIVE_FAIL = "BUSINESS_UNIT_ACTIVE_FAIL";
export const BUSINESS_UNIT_ACTIVE_RESET = "BUSINESS_UNIT_ACTIVE_RESET";
